"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createRedirect = void 0;
var _utils = require("../utils");
var _entityLite = require("./entity-lite");
var _anchor = _interopRequireDefault(require("./anchor"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createRedirect = function createRedirect(_ref) {
  var fields = _ref.fields;
  var source = (0, _utils.getProp)(fields, 'source');
  var destination = (0, _utils.getProp)(fields, 'destination');
  var params = new URLSearchParams((0, _utils.getProp)(fields, 'destinationUrlParameters'));
  var query = params.toString().length ? "?".concat(params.toString()) : '';
  var anchorPoint = (0, _utils.getProp)(fields, 'destinationAnchorPoint');
  var hash = anchorPoint ? "#".concat((0, _anchor["default"])(anchorPoint).slug) : '';
  return {
    source: source ? "/".concat(source) : null,
    destination: destination ? "".concat((0, _entityLite.createEntityLite)(destination).url).concat(query).concat(hash) : null,
    permanent: (0, _utils.getProp)(fields, 'permanent') || false
  };
};
exports.createRedirect = createRedirect;
var redirectFactory = function redirectFactory(items) {
  if (!items) return [];
  return items.map(function (item) {
    return createRedirect(item);
  }).filter(function (redirect) {
    return !!redirect.source && !!redirect.destination;
  });
};
var _default = redirectFactory;
exports["default"] = _default;